import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const SlideoutScreeningCard = ({ cardTitle, icon, iconColor, isError = false, status }) => {
    return (React.createElement(Box, { sx: [{ alignItems: 'center', display: 'flex' }, isError ? { color: themeColors.accent.red.bold } : {}] },
        React.createElement(Box, { sx: { alignItems: 'center', color: iconColor, display: 'flex' } }, icon),
        React.createElement(Typography, { sx: { ml: 2 }, variant: 'body2' },
            React.createElement(Typography, { component: 'span', variant: 'inherit' },
                cardTitle,
                ":",
                ' '),
            React.createElement(Typography, { component: 'span', fontWeight: 500, variant: 'inherit' }, status))));
};
